module.exports = __webpack_public_path__ + "static/npckc3-8c8954faf890da78678b4f05c6b8fe71.webp";